import { render, staticRenderFns } from "./FacebookPages.vue?vue&type=template&id=da61bc16&scoped=true&"
import script from "./FacebookPages.vue?vue&type=script&lang=js&"
export * from "./FacebookPages.vue?vue&type=script&lang=js&"
import style0 from "./FacebookPages.vue?vue&type=style&index=0&id=da61bc16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da61bc16",
  null
  
)

export default component.exports